// test2548
(2548 && 0);
